import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { images } from 'utils/icons';
import Image from 'components/Image';
import TextInput from '../TextInput';
import IconButton from '@material-ui/core/IconButton';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';

const useStyles = makeStyles(() => ({
  textInputContainer: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  container: {
    width: '100%',
  },
  input: {
    flex: 1,
  },
  label: {
    color: '#9f9bc8',
  },
  displayContainer: {},
}));

const ArrayAddition = ({ onChange, value = [], label }) => {
  const classes = useStyles();
  const [tempText, setTempText] = useState();

  const handleInput = evt => {
    setTempText(evt.target.value.toUpperCase());
  };

  const handleBtnClick = () => {
    const findUniq = new Set(value.concat(tempText));
    const array = Array.from(findUniq);
    onChange(array);
    setTempText('');
  };

  const removeAddedItem = text => {
    const remainingItems = value.filter(item => item !== text);
    onChange(remainingItems);
  };

  return (
    <div className={classes.container}>
      <div className={classes.textInputContainer}>
        <TextInput
          id={label}
          placeholder={label}
          field={label}
          label={label}
          value={tempText}
          className={classes.input}
          onChange={handleInput}
        />
        {tempText && (
          <Image src={images.addMedia.default} onClick={handleBtnClick} />
        )}
      </div>
      <div className={classes.displayContainer}>
        {value.length > 0 && (
          <table>
            <thead>
              <tr className={classes.label}>{`Added ${label}`}</tr>
            </thead>
            <tbody>
              {value.map((item, index) => (
                <tr key={index}>
                  <td>{item}</td>
                  <td>
                    <IconButton
                      color="secondary"
                      component="div"
                      className={classes.icon}
                      onClick={() => removeAddedItem(item)}
                    >
                      <DeleteOutlineIcon color="disabled" />
                    </IconButton>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

ArrayAddition.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.arrayOf(PropTypes.string),
  label: PropTypes.string,
};

export default ArrayAddition;
